import {createEvent} from 'effector';
import {createGate} from 'effector-react';

export const UnpublishedGate = createGate()
export const approveProjectEv = createEvent()
export const rejectProjectEv = createEvent()

export const setRejectModalEv = createEvent()